import * as React from "react";
import type { SVGProps } from "react";
const SvgSauna = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m12.6 2.2 8 6c.25.19.4.49.4.8v12c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V9c0-.31.15-.61.4-.8l8-6a.99.99 0 0 1 1.2 0M5 9.5V20h14V9.5l-7-5.25zm2.44.67c.46-.3 1.08-.18 1.39.28h-.01c1.32 1.98.59 3.44.06 4.5-.48.96-.74 1.48-.06 2.5.3.46.18 1.08-.28 1.39-.17.12-.36.17-.55.17-.32 0-.64-.16-.83-.45-1.32-1.98-.59-3.44-.06-4.5.48-.96.74-1.48.06-2.5-.3-.46-.18-1.09.28-1.39m4.06-1.03c-.48.28-.64.89-.36 1.37.74 1.28.43 2-.05 3.1-.54 1.23-1.2 2.75.05 4.9.19.32.52.5.87.5.17 0 .34-.04.5-.14.48-.28.64-.89.36-1.37-.74-1.28-.43-2 .05-3.1.54-1.23 1.2-2.75-.05-4.9a1 1 0 0 0-1.37-.36m4.5 9.87c-.32 0-.64-.16-.83-.45h-.01c-1.32-1.98-.59-3.44-.06-4.5.48-.96.74-1.48.06-2.5-.3-.46-.18-1.09.28-1.39s1.08-.18 1.39.28c1.32 1.98.59 3.44.06 4.5-.48.96-.74 1.48-.06 2.5.3.46.18 1.08-.28 1.39-.17.12-.36.17-.55.17"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSauna;
